module.exports = __webpack_public_path__ + "media/NUMER_PIN.d352229b.mp3";